import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { Collapse, fade, IconButton, Link } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';

import CmtImage from '../../../../@coremat/CmtImage';

import IntlMessages from '../../../utils/IntlMessages';
// import { AuhMethods } from '../../../../services/auth';
import ContentLoader from '../../ContentLoader';
import { CurrentAuthMethod } from '../../../constants/AppConstants';
import AuthWrapper from './AuthWrapper';
import { setForgetPassMailSent } from '../../../../redux/actions/Auth';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';
import clsx from 'clsx';

import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const useStyles = makeStyles(theme => ({
  authThumb: {
    backgroundColor: fade(theme.palette.primary.main, 0.12),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    [theme.breakpoints.up('md')]: {
      width: '50%',
      order: 1,
    },
  },
  authContent: {
    padding: 30,
    [theme.breakpoints.up('md')]: {
      order: 1,
      width: props => (props.variant === 'default' ? '50%' : '100%'),
    },
    [theme.breakpoints.up('xl')]: {
      padding: 50,
    },
  },
  titleRoot: {
    marginBottom: 14,
    color: theme.palette.text.primary,
  },
  textFieldRoot: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: fade(theme.palette.common.dark, 0.12),
    },
  },
  alertRoot: {
    marginBottom: 10,
  },
  buttonStyle: {
    padding: '10px 32px',
    fontSize: '16px',
    color: 'white',
    fontWeight: 600,
    textTransform: 'capitalize',
    borderRadius: '4px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
}));

//variant = 'default', 'standard', 'bgColor'
const ForgotPassword = ({ method = CurrentAuthMethod, variant = 'default', wrapperVariant = 'default' }) => {
  const { send_forget_password_email } = useSelector(({ auth }) => auth);
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('contact@johndoe.com');
  const [otp, setOtp] = useState('999999');
  const [newPassword, setNewPassword] = useState('Password100@');
  const [showPassword, setShowPassword] = useState(false);
  const [confirmNewPassword, setConfirmNewPassword] = useState('Password100@');
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
  const dispatch = useDispatch();
  const classes = useStyles({ variant });
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('success');
  const [forgotPasswordForm, setforgotPasswordForm] = useState(true);
  const [otpForm, setOtpForm] = useState(false);
  const [resetPasswordForm, setResetPasswordForm] = useState(false);

  const fnShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const fnShowRePassword = () => {
    setShowConfirmNewPassword(!showConfirmNewPassword);
  };
  const handleMouseDownPassword = event => {
    event.preventDefault();
  };
  // useEffect(() => {
  //   let timeOutStopper = null;
  //   if (send_forget_password_email) {
  //     setOpen(true);

  //     timeOutStopper = setTimeout(() => {
  //       dispatch(setForgetPassMailSent(false));
  //       history.push('/');
  //     }, 1500);
  //   }

  //   return () => {
  //     if (timeOutStopper) clearTimeout(timeOutStopper);
  //   };
  //   //eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [send_forget_password_email]);

  // const onSubmit = () => {
  //   dispatch(AuhMethods[method].onForgotPassword({ email }));
  // };

  const onSubmit = async e => {
    // console.log('onSubmit');
    e.preventDefault();
    setLoading(true);
    let response;

    try {
      if (forgotPasswordForm) {
        response = await axios({
          url: `/api/v1/public/auth/forgot-password/send-otp?email=${email}`,
          method: 'get',
        });
      } else if (otpForm) {
        response = await axios({
          url: `/api/v1/public/auth/forgot-password/verify-otp`,
          method: 'post',
          data: { email, otp },
        });
        // console.log('otpForm Submit', email, otp);
      } else if (resetPasswordForm) {
        response = await axios({
          url: `/api/v1/public/auth/forgot-password/reset-password`,
          method: 'post',
          data: { email, otp, newPassword, confirmNewPassword },
        });
        // console.log('resetPasswordForm Submit', email, otp, newPassword, confirmNewPassword);
      }

      // history.push({pathname:"/otp-send", state: {email: email}});
      // console.log('5');
      setMessage(response.data.message);
      setSeverity('success');
      setOpen(true);
      setTimeout(function() {
        if (forgotPasswordForm) {
          setforgotPasswordForm(false);
          setOtpForm(true);
        } else if (otpForm) {
          setOtpForm(false);
          setResetPasswordForm(true);
        } else if (resetPasswordForm) {
          setforgotPasswordForm(false);
          history.push('/signin');
        }

        setOpen(false);
      }, 1500);
    } catch (error) {
      // console.log('error', error);
      // console.log('errorresponse', error.response);
      setMessage(error.response.data.errors.toString());
      setSeverity('error');
      setOpen(true);
    }
    setLoading(false);
  };

  return (
    <AuthWrapper variant={wrapperVariant}>
      {variant === 'default' ? (
        <div className={classes.authThumb}>
          <CmtImage src={'/images/auth/forgot-img.png'} />
        </div>
      ) : null}
      <div className={classes.authContent}>
        {loading ? <LinearProgress /> : null}
        <div className={'mb-7'}>
          <CmtImage src="/images/logo.png" alt="Shimanto Bank" style={{ maxHeight: 56, width: 'auto', objectFit: 'contain' }} />
        </div>

        <Typography component="div" variant="h1" className={classes.titleRoot}>
          {forgotPasswordForm && 'Forgot Password'}
          {otpForm && 'Enter OTP'}
          {resetPasswordForm && 'Reset Password'}
        </Typography>
        <Collapse in={open}>
          <Alert
            variant="outlined"
            severity={severity}
            className={classes.alertRoot}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setOpen(false);
                }}>
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }>
            {message}
          </Alert>
        </Collapse>
        <form>
          {forgotPasswordForm && (
            <div className={'mb-5'}>
              <TextField
                label={<IntlMessages id="appModule.email" />}
                fullWidth
                onChange={event => setEmail(event.target.value)}
                value={email}
                margin="normal"
                variant="outlined"
                className={classes.textFieldRoot}
              />
            </div>
          )}
          {otpForm && (
            <div className={'mb-5'}>
              <TextField
                label="OTP"
                fullWidth
                onChange={event => setOtp(event.target.value)}
                value={otp}
                margin="normal"
                variant="outlined"
                className={classes.textFieldRoot}
              />
            </div>
          )}
          {resetPasswordForm && (
            <div>
              <div className={'mb-5'}>
                <FormControl variant="outlined" fullWidth style={{ marginTop: '15px' }}>
                  <InputLabel htmlFor="outlined-adornment-newPassword">New Password</InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-newPassword"
                    type={showPassword ? 'text' : 'newPassword'}
                    value={newPassword}
                    onChange={e => setNewPassword(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle newPassword visibility"
                          onClick={fnShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end">
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }
                    labelWidth={120}
                  />
                </FormControl>
              </div>
              <div className={'mb-5'}>
                <FormControl variant="outlined" fullWidth style={{ marginTop: '15px', marginBottom: '10px' }}>
                  <InputLabel htmlFor="outlined-adornment-newPassword">Confirm New Password</InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-newPassword"
                    type={showConfirmNewPassword ? 'text' : 'newPassword'}
                    value={confirmNewPassword}
                    onChange={e => setConfirmNewPassword(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle newPassword visibility"
                          onClick={fnShowRePassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end">
                          {showConfirmNewPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }
                    labelWidth={190}
                  />
                </FormControl>
              </div>
            </div>
          )}

          <div className={'mb-5'}>
            <Button onClick={onSubmit} variant="contained" color="primary">
              Continue
            </Button>
          </div>

          <div>
            <Typography>
              Don't remember your email?
              <span className={'ml-2'}>
                <Link href="#">
                  <IntlMessages id="appModule.contactSupport" />
                </Link>
              </span>
            </Typography>
          </div>
        </form>
        <ContentLoader />
      </div>
    </AuthWrapper>
  );
};

export default ForgotPassword;
